export const eventSettings = {
  title: 'Events',
  description: 'Choose the leagues you want surfaced across dashboards and widgets.',
  autoSelectLabel: 'Auto Selection Events',
  autoSelectDescription:
    'Automatically subscribe to trending leagues when new tournaments begin.',
   defaultLeagues: [
     [
       { id: 'premier-league', label: 'Premier League' },
       { id: 'la-liga', label: 'La Liga' },
       { id: 'bundesliga', label: 'Bundesliga' },
       { id: 'serie-a', label: 'Serie A' },
       { id: 'ligue-1', label: 'France Ligue 1' },
       { id: 'eredivisie', label: 'Eredivisie' },
       { id: 'major-league-soccer', label: 'Major League Soccer' },
      { id: 'indian-super-league', label: 'Indian Super League' },
      { id: 'k-league-1', label: 'K League 1' },
      { id: 'j-league', label: 'J League' },
      { id: 'primeira-liga', label: 'Primeira Liga' },
      { id: 'a-league', label: 'A-League Men' },
     ]
    ]
  //   [
  //     { id: 'major-league-soccer', label: 'Major League Soccer' },
  //     { id: 'indian-super-league', label: 'Indian Super League' },
  //     { id: 'k-league-1', label: 'K League 1' },
  //     { id: 'j-league', label: 'J League' },
  //     { id: 'primeira-liga', label: 'Primeira Liga' },
  //     { id: 'a-league', label: 'A-League Men' },
  //   ],
  // ],
};

export const actionShortcuts = {
  title: 'Quick Actions',
  description: 'Jump into the tools you need most during live trading windows.',
  maxSelectable: 5,
  defaultSelected: ['report', 'account', 'settings'],
  items: [
    { id: 'report', label: 'Report' },
    { id: 'account', label: 'Account' },
    { id: 'settings', label: 'Setting' },
    { id: 'user', label: 'User' },
    { id: 'transaction', label: 'Transaction' },
    { id: 'sportsbook', label: 'Sportsbook' },
    { id: 'profile', label: 'Profile' },
    { id: 'condition', label: 'Condition' },
    { id: 'payment', label: 'Payment' },
    { id: 'league', label: 'League' },
    { id: 'audit', label: 'Audit Trail' },
    { id: 'limits', label: 'Limits' },
  ],
};

export const notificationSettings = {
  title: 'Notification',
  description: 'Toggle alerts that keep your trading desk aligned in real time.',
  items: [
    //{ id: 'theme', label: 'Theme', description: 'Sync dark and light mode preferences across devices.', defaultEnabled: true },
    {
      id: 'stake',
      label: 'Stake Notification',
      description: 'Get alerted when incoming stakes breach your configured limits.',
      //defaultEnabled: true,
    },
    {
      id: 'odds',
      label: 'Odds Notification',
      description: 'Receive immediate alerts on significant odds fluctuations.',
      //defaultEnabled: true,
    },
    {
      id: 'result',
      label: 'Result Notification',
      description: 'Push final results as soon as an event is settled.',
      //defaultEnabled: false,
    },
    {
      id: 'settlement',
      label: 'Settlement Notification',
      description: 'Notify traders when settlement batches complete.',
      //defaultEnabled: false,
    },
  ],
};
